import axios, { AxiosResponse, CancelToken } from "axios";
import { LogEvent, GetUnifiedLogsRequest } from "../../models/LogEvents";

export const getTwilioAllLogsPage =
	(request: GetUnifiedLogsRequest, subscriptionId: string, productId: string, accountSid: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<LogEvent[]>> => {
		return await axios.post(`/api/v1/${productId}/Twilio/AllLogs/${subscriptionId}/${accountSid}/AllLogs`, request, {
			cancelToken: cancelToken,
		});
	};
